<!--
@component
MatchStrip

See markup below.
-->

<script lang="ts">
  import type { Match } from '$lib/@types/opta';
  import getMatchPath from '$utils/getMatchPath';
  import { getAwayTeam, getHomeTeam, isPlaying } from '$utils/getMatchStats';
  import { appState } from '$lib/stores/index.svelte';
  import Card from './Match/index.svelte';

  type Props = {
    match: Match;
    link?: boolean;
  };

  let { match, link = false }: Props = $props();

  const matchUrl = $derived(getMatchPath(match)?.url);
  const hasTeams = $derived(!!getHomeTeam(match) && !!getAwayTeam(match));
  const wrap = $derived(link && hasTeams && !!matchUrl && matchUrl !== '.');
  // Live strips need to stack above adjacent strips so the LiveBug, which
  // overflows the bottom edge of the card, isn't hidden by the next strip.
  const isLive = $derived(isPlaying(match));
</script>

{#snippet card()}
  <Card {match} />
{/snippet}

{#if wrap}
  <a
    href={matchUrl}
    target={appState.embed ? '_top' : undefined}
    class:loading={appState.isLoading}
    class:isLive
  >
    {@render card()}
  </a>
{:else}
  <div class="strip-wrapper" class:isLive>
    {@render card()}
  </div>
{/if}

<style lang="scss">
  @use '../../../styles/mixins' as mixins;
  a {
    margin: auto;
    text-decoration: inherit;
    color: inherit;
    display: block;
    border-radius: calc(10 * var(--theme-style-border-radius));

    &.loading {
      pointer-events: none;
      cursor: default;
    }

    @include mixins.hover-supported() {
      opacity: 0.9;
      text-decoration: inherit;
      color: inherit;
    }
  }

  // When the strip is live, raise the wrapper above adjacent siblings so the
  // LiveBug (which is positioned outside the bottom edge of the card) remains
  // visible and isn't clipped by the next strip stacked below.
  .isLive,
  a.isLive {
    position: relative;
    z-index: 2;
  }

  .strip-wrapper {
    display: block;
  }
</style>
